import { useTranslation } from 'next-i18next';
import { Box, ButtonV2 as Button, Rating } from '@bridebook/ui';
import { IconAdd, IconTestimonials } from '@bridebook/ui/src/icons';
import { Reviews } from '@bridebook/web/app-shared/lib/supplier/types';
import styles from './accordion-custom.style';

interface IProps {
  withAddReview: boolean;
  reviews: Reviews;
  totalTestimonials: number;
  onAddReviewClick?(): void;
}

const AccordionCustom = ({
  reviews: { hasReviews, hasTestimonials, stars },
  withAddReview,
  onAddReviewClick,
  totalTestimonials,
}: IProps) => {
  const { t } = useTranslation('supplier');
  const hasSomethingToShow = hasReviews || hasTestimonials;

  return (
    <Box style={styles.wrapper}>
      <Box style={styles.statsWrap}>
        {hasReviews && <Rating rating={stars} />}
        {!hasReviews && hasTestimonials && (
          <Box style={styles.totalWrapper}>
            <Box style={styles.iconWrap} mr={2}>
              <IconTestimonials color="silver" width={17} />
            </Box>
            <Box>({totalTestimonials})</Box>
          </Box>
        )}
        {!hasSomethingToShow && <Box style={styles.noReviewsLabel}>{t('noReviews.caption')}</Box>}
      </Box>
      {withAddReview && (
        <Box style={styles.buttonWrap}>
          <div className="supplier-add-review">
            <Button size="small" startIcon={<IconAdd width={12} />} onClick={onAddReviewClick}>
              {t('button.addReview')}
            </Button>
          </div>
        </Box>
      )}
    </Box>
  );
};

export default AccordionCustom;
